/**
 * The MediaPipe PoseLandmarker configuration, shared by both extraction paths: the upload-time
 * one (ExtractionStep, over the picked video) and the post-split one (imagePose, over the split
 * frame PNGs). One definition so the two can never drift onto different models — modelVersion is
 * recorded in every pose file, and a mismatch there would misattribute the labels.
 *
 * Tier: HEAVY, the most accurate of MediaPipe's lite / full / heavy. We label still frames, not a
 * live camera, so there is no frame-rate to hit; the cost is a larger one-off model download and a
 * longer run. Changing the tier is a labelling-quality change — bump MODEL_VERSION with it.
 */
export const MODEL_VERSION = "mediapipe-tasks-vision-0.10-pose_landmarker_heavy";

export const MODEL_URL =
  "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_heavy/float16/1/pose_landmarker_heavy.task";

// Must match the bundled @mediapipe/tasks-vision JS version (package.json) — pinned by test.
export const WASM_ROOT = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm";
